import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import CfcRegistration from './CfcRegistration';

export default function CfcDraggableRegistration({cfcRegistration}) {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform
  } = useDraggable({
    id: cfcRegistration.id
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

  return (
    <div style={style} {...attributes} {...listeners} ref={setNodeRef}>
      <CfcRegistration cfcRegistration={cfcRegistration}></CfcRegistration>
    </div>
  )
}
